import {ObjectListSortOrderValue} from "../../../constants/constants";
import {SearchCond} from "../components/forms/SearchForm";
import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";
import {findObject} from "../../../utils/awsAmplifyUtil";
import {FindObjectResponse} from "../../../types/pj1dbApiObject";

export interface UseObjectParams {
  searchCond: SearchCond<ObjectListSortOrderValue>;
  onChange: (newData: FindObjectResponse[], newStatus: Status) => void
  enableAutoFetch?: boolean,
  initialStatus?: Status,
}

export function useObject(params: UseObjectParams) {
  const result = useFetchAllQuery({
    queryFn: (query) => findObject({
      body: {
        'query-attr': {
          ...(params.searchCond.keyword === "" ? {} : {
            $or: [
              {'object-pkg-original-name': {"$regex": params.searchCond.keyword, "$options": "i"}},
              {original_name: {"$regex": params.searchCond.keyword, "$options": "i"}},
            ]
          }),
        },
      },
      query
    }),
    needToFetchMore: (data, limit) => Object.entries(data.object ?? {}).length === limit,
    enableAutoFetch: params.enableAutoFetch,
  });
  const helperResult = useFetchAllQueryHelper({
    onChange: params.onChange,
    data: result.data,
    status: result.status,
    initialStatus: params.initialStatus,
  });

  return {
    ...result,
    ...helperResult,
  }
}
